import { useState, useEffect } from 'react';
import { supabase } from './supabase';

/**
 * useRole — resolves whether the logged-in user is an INSTRUCTOR or the ADMIN.
 *
 * Logic: does this auth user map to an instructors row via auth_user_id?
 *   - Yes  → role 'instructor', returns their full instructor row.
 *   - No   → role 'admin' (the god-view / current dashboard).
 *
 * This is how one login lands on the right surface (Option A: two surfaces,
 * one shared database).
 */
export function useRole(session) {
  const [state, setState] = useState({ loading: true, role: null, instructor: null });

  useEffect(() => {
    let cancelled = false;

    async function resolve() {
      if (!session?.user) {
        if (!cancelled) setState({ loading: false, role: null, instructor: null });
        return;
      }

      const { data } = await supabase
        .from('instructors')
        .select('*')
        .eq('auth_user_id', session.user.id)
        .maybeSingle();

      if (cancelled) return;

      if (data) {
        setState({ loading: false, role: 'instructor', instructor: data });
      } else {
        // No instructor mapping → this is the admin.
        setState({ loading: false, role: 'admin', instructor: null });
      }
    }

    resolve();
    return () => { cancelled = true; };
  }, [session]);

  return state;
}